import { formatMoney } from "helpers";
import { getShortDateUSStyle } from "helpers/date";
import { ReactComponent as RightIcon } from "assets/expand.svg";
import { FC } from "react";
import styles from "./List.module.scss";
import { Box, Group, Pill, Text } from "@mantine/core";

interface Props {
  list: any[];
  isRisk: boolean;
  onClick: (oppOrRisk: any) => void;
}

const List: FC<Props> = ({ list, isRisk, onClick }) => {
  return (
    <ul className={styles["opp-list"]}>
      {list.map((o, index) => (
        <li key={index}  onClick={() => {
          onClick(o);
        }}>
          <Box className={styles["opp-list__item"]}>
            <div className={styles["opp-list__item-index"]}>{index + 1}.</div>
            <div className={styles["opp-list__item-value"]}>
              {/*!o.products || o.products?.filter((p) => p.quantity).length === 0 ? (
                      <h1 className={styles["opp-list__item-value--proj"]}>{((o.annual_estimate || 0)/1000).toFixed(2)}k</h1>
                    ): (
                      <h5 className={styles["opp-list__item-awaiting"]}>
                        Awaiting Netsuite Data
                      </h5>
                    )*/}
              {/*<p>{new Date(o.expected_close_date).toLocaleDateString()}</p>*/}
              {(
                //!(o.products && o.products.filter((p) => p.quantity).length > 0)
                o.projected_total !== null && o.projected_total !== undefined
              ) ? (
                <div className={styles["opp-list__item-norm-wrapper"]}>
                  {isRisk ? (
                    <h1
                      className={styles["opp-list__item-value--proj-risk"]}>
                      {/*((o.annual_estimate || 0) / 1000).toFixed(2)*/}{/*k*/}
                      -{formatMoney((o.projected_total + "" || "0"), true)}
                    </h1>
                  ) : (
                    <h1 className={styles["opp-list__item-value--proj"]}>
                      {/*((o.annual_estimate || 0) / 1000).toFixed(2)*/}{/*k*/}
                      {formatMoney((o.projected_total + "" || "0"), true)}
                    </h1>
                  )}
                  <p className={styles["opp-list__item-date"]}>
                    By {getShortDateUSStyle(new Date(o.expected_close_date))}
                  </p>
                </div>
              ) : (
                <div className={styles["opp-list__item-awaiting-wrapper"]}>
                  <div className={styles["opp-list__item-awaiting"]}>
                    Awaiting Netsuite Data
                  </div>
                  <p className={styles["opp-list__item-date"]}>
                    {/*new Date(o.expected_close_date).toLocaleDateString()*/}
                    By {getShortDateUSStyle(new Date(o.expected_close_date))}
                  </p>
                </div>
              )}
            </div>
            <div className={styles["opp-list__item-sub-list"]}>
              <h5>{o.status}</h5>
              <ol>
                {(o?.products ?? []).slice(0, 3).map((p: any, i: number) => (
                  <li key={`o_${i}`}>{p?.name?.slice(0, 15)}: {p.quantity} units</li>
                ))}
              </ol>
            </div>
            
            <RightIcon className={styles["opp-list__item-action"]} />
            
          </Box>
          <Group justify="space-between" mb="xs" ml={60}>
            <Box>
              <Text 
                my={0}
                py={0}
                c="#4F7D9C" 
                fw="bold">
                  {o?.practitioner_name}
              </Text>
              <Text c="dimmed" fz="h6" mt={-5}>
                {o?.specialty}
              </Text>
            </Box>
            {o.close_date ? (
              <Pill
                radius={5}
                bg="#32E26D"
                c="white"
                size="xs">Closed</Pill>
            ) : null }
            {o.is_risk && !o.close_date ? (
              <Pill
                radius={5}
                bg="#FEF2F2"
                c="#DC2626"
                size="xs"
                style={{ border: '1px solid #FECACA' }}>At-Risk</Pill>
            ) : null }
          </Group>
        </li>
      ))}
    </ul>
  )
};

export default List;